module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/mail-opened-2344d802dd6d16ade66d92b4d2f8a337.svg";